import { FaPrint, FaTimes, FaReceipt } from 'react-icons/fa';

const CupomFiscalModal = ({ show, onClose, onPrint, dados }) => {
  if (!show) return null;

  const mascararCPF = (cpf) => {
    if (!cpf) return '***.***.***-**';
    const cpfLimpo = cpf.replace(/\D/g, '');
    if (cpfLimpo.length !== 11) return cpf;
    return `${cpfLimpo.substring(0, 3)}.***.***-${cpfLimpo.substring(9)}`;
  };


  const { litros, solicitacao, posto, precoLitro, user } = dados;

  const calcularValorTotal = () => {
    if (!litros || !precoLitro) return 'R$ 0,00';

    const valor = parseFloat(litros) * parseFloat(precoLitro);

    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handlePrint = () => {
    const printContent = document.getElementById('cupom-print');
    
    if (printContent) {
      // comprovante
      const htmlContent = `
        <!DOCTYPE html>
        <html>
          <head>
            <title>COMPROVANTE DE ABASTECIMENTO</title>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <style>
              * {
                margin: 0 !important;
                padding: 0 !important;
                box-sizing: border-box !important;
              }
              
              html, body {
                margin: 0 !important;
                padding: 0 !important;
                width: 100% !important;
                height: 100% !important;
                background: white !important;
                display: flex !important;
                justify-content: center !important;
                align-items: center !important;
                font-family: 'Arial Black', 'Impact', 'Franklin Gothic Bold', 'Arial Narrow', sans-serif !important;
              }
              
              .cupom-container {
                width: 100% !important;
                max-width: 100% !important;
                height: 100% !important;
                padding: 25px !important;
                background: white !important;
                border: none !important;
                font-family: 'Arial Black', 'Impact', 'Franklin Gothic Bold', 'Arial Narrow', sans-serif !important;
                font-size: 18px !important;
                line-height: 2.0 !important;
                font-weight: 900 !important;
                color: #000000 !important;
                letter-spacing: 1.5px !important;
                text-transform: uppercase !important;
                display: flex !important;
                flex-direction: column !important;
                justify-content: space-between !important;
              }
              
              .cupom-container,
              .cupom-container * {
                font-weight: 900 !important;
                color: #000000 !important;
                font-family: 'Arial Black', 'Impact', 'Franklin Gothic Bold', 'Arial Narrow', sans-serif !important;
                text-transform: uppercase !important;
              }
              
              .cupom-header {
                text-align: center !important;
                margin-bottom: 15px !important;
              }
              
              .cupom-fiscal-title {
                font-size: 28px !important;
                font-weight: 900 !important;
                letter-spacing: 4px !important;
                margin: 0 0 8px 0 !important;
                text-transform: uppercase !important;
                font-family: 'Arial Black', 'Impact', sans-serif !important;
              }
              
              .cupom-id-abastecimento {
                font-size: 26px !important;
                font-weight: 900 !important;
                letter-spacing: 3px !important;
                margin: 8px 0 !important;
                padding: 12px 20px !important;
                background: #f0f0f0 !important;
                border: 3px solid #000 !important;
                font-family: 'Arial Black', 'Impact', sans-serif !important;
                display: inline-block !important;
              }
              
              .cupom-estabelecimento {
                text-align: center !important;
                margin: 12px 0 !important;
              }
              
              .cupom-posto-label {
                font-size: 24px !important;
                font-weight: 900 !important;
                margin: 0 0 2px 0 !important;
                text-transform: uppercase !important;
                letter-spacing: 2px !important;
              }
              
              .cupom-estabelecimento-nome {
                font-size: 24px !important;
                font-weight: 900 !important;
                margin: 0 0 6px 0 !important;
                font-family: 'Arial Black', 'Impact', sans-serif !important;
                text-transform: uppercase !important;
              }
              
              .cupom-estabelecimento-endereco {
                font-size: 18px !important;
                font-weight: 900 !important;
                margin: 0 !important;
                text-transform: uppercase !important;
              }
              
              .cupom-fiscal-divider {
                border: none !important;
                border-top: 4px solid #000 !important;
                margin: 12px 0 !important;
                height: 0 !important;
              }
              
              .cupom-info-row {
                display: flex !important;
                justify-content: space-between !important;
                padding: 4px 0 !important;
                font-size: 19px !important;
                font-weight: 900 !important;
              }

              .cupom-info-row-small {
                display: flex;
                gap: 5px;
                font-size: 10px;
              }
              
              .cupom-info-label {
                font-weight: 900 !important;
                font-size: 19px !important;
                text-transform: uppercase !important;
              }
              
              .cupom-info-value {
                font-weight: 900 !important;
                font-size: 19px !important;
                text-transform: uppercase !important;
              }
              
              .cupom-placa-veiculo {
                display: flex !important;
                flex-direction: column !important;
                gap: 2px !important;
                padding: 4px 0 !important;
              }
              
              .cupom-placa-veiculo .cupom-info-row-small {
                padding: 2px 0 !important;
              }
              
              .cupom-divider-veiculo {
                display: none !important;
              }
              
              .cupom-tabela-itens {
                margin: 12px 0 !important;
              }
              
              .cupom-tabela-header {
                display: flex !important;
                font-size: 18px !important;
                font-weight: 900 !important;
                padding: 8px 0 !important;
                border-bottom: 4px solid #000 !important;
                text-transform: uppercase !important;
              }
              
              .cupom-tabela-row {
                display: flex !important;
                font-size: 19px !important;
                padding: 8px 0 !important;
                font-weight: 900 !important;
              }
              
              .cupom-col-qtd {
                width: 100px !important;
                text-align: left !important;
                font-weight: 900 !important;
                font-size: 19px !important;
                text-transform: uppercase !important;
              }
              
              .cupom-col-desc {
                flex: 1 !important;
                text-align: left !important;
                padding-left: 15px !important;
                font-weight: 900 !important;
                font-size: 19px !important;
                text-transform: uppercase !important;
              }
              
              .cupom-col-valor {
                width: 130px !important;
                text-align: right !important;
                font-weight: 900 !important;
                font-size: 19px !important;
                text-transform: uppercase !important;
              }
              
              .cupom-total-row {
                display: flex !important;
                justify-content: space-between !important;
                font-size: 30px !important;
                font-weight: 900 !important;
                font-family: 'Arial Black', 'Impact', sans-serif !important;
                background: #f0f0f0 !important;
                padding: 15px !important;
                margin: 10px 0 !important;
                border: 3px solid #000 !important;
              }
              
              .cupom-total-label {
                text-transform: uppercase !important;
                font-weight: 900 !important;
                font-size: 30px !important;
              }
              
              .cupom-total-value {
                font-weight: 900 !important;
                font-size: 30px !important;
                font-family: 'Arial Black', 'Impact', sans-serif !important;
              }
              
              .cupom-assinatura {
                text-align: center !important;
                margin: 20px 0 15px 0 !important;
              }
              
              .cupom-assinatura-texto {
                font-size: 18px !important;
                font-weight: 900 !important;
                margin: 0 0 12px 0 !important;
                text-transform: uppercase !important;
              }
              
              .cupom-assinatura-linha {
                font-size: 22px !important;
                font-weight: 900 !important;
                margin: 0 0 6px 0 !important;
                letter-spacing: 3px !important;
              }
              
              .cupom-assinatura-label {
                font-size: 16px !important;
                font-weight: 900 !important;
                margin: 0 !important;
                letter-spacing: 3px !important;
                text-transform: uppercase !important;
              }
              
              .cupom-fiscal-footer {
                text-align: center !important;
                font-size: 15px !important;
                margin-top: 15px !important;
                padding-top: 12px !important;
                border-top: 4px solid #000 !important;
                font-weight: 900 !important;
              }
              
              .cupom-fiscal-footer p {
                margin: 4px 0 !important;
                font-weight: 900 !important;
                font-size: 15px !important;
                text-transform: uppercase !important;
              }
              
              .mono {
                font-weight: 900 !important;
                font-family: 'Arial Black', 'Impact', sans-serif !important;
              }
              
              @page {
                size: auto !important;
                margin: 0 !important;
                padding: 0 !important;
              }
              
              @media print {
                html, body {
                  margin: 0 !important;
                  padding: 0 !important;
                  width: 100% !important;
                  height: 100% !important;
                }
                
                .cupom-container {
                  padding: 20px !important;
                }
              }
            </style>
          </head>
          <body>
            <div class="cupom-container">
              <div>
                <!-- Cabeçalho com ID -->
                <div class="cupom-header">
                  <h2 class="cupom-fiscal-title">COMPROVANTE DE ABASTECIMENTO</h2>
                  <div class="cupom-id-abastecimento">
                    CÓDIGO: ${solicitacao?.id?.toString().padStart(6, '0') || '000000'}
                  </div>
                  <div class="cupom-fiscal-divider"></div>
                </div>

                <!-- Estabelecimento -->
                <div class="cupom-estabelecimento">
                  <p class="cupom-posto-label">POSTO</p>
                  <h3 class="cupom-estabelecimento-nome">${(posto?.nome || 'POSTO NÃO INFORMADO').toUpperCase()}</h3>
                  <p class="cupom-estabelecimento-endereco">${(posto?.endereco || 'ENDEREÇO NÃO INFORMADO').toUpperCase()}</p>
                </div>

                <div class="cupom-fiscal-divider"></div>

                <!-- Motorista -->
                <div class="cupom-info-row">
                  <span class="cupom-info-label">MOTORISTA:</span>
                  <span class="cupom-info-value">${(solicitacao?.motorista?.nome || solicitacao?.motorista || 'NÃO INFORMADO').toUpperCase()}</span>
                </div>
                <div class="cupom-info-row">
                  <span class="cupom-info-label">CPF:</span>
                  <span class="cupom-info-value">${mascararCPF(solicitacao?.motorista?.cpf)}</span>
                </div>

                <div class="cupom-fiscal-divider"></div>

                <!-- PLACA e VEÍCULO -->
                <div class="cupom-placa-veiculo">
                  <div class="cupom-info-row-small">
                    <span class="cupom-info-label">LOCAL:</span>
                    <span class="cupom-info-value">${(solicitacao?.veiculo?.local || '-').toUpperCase()}</span>
                  </div>
                  <div class="cupom-info-row-small">
                    <span class="cupom-info-label">PLACA:</span>
                    <span class="cupom-info-value">${(solicitacao?.veiculo?.placa || '-').toUpperCase()}</span>
                  </div>
                  <div class="cupom-info-row-small">
                    <span class="cupom-info-label">VEÍCULO:</span>
                    <span class="cupom-info-value">${(solicitacao?.veiculo?.descricao || '-').toUpperCase()}</span>
                  </div>
                </div>

                <div class="cupom-fiscal-divider"></div>

                <!-- Tabela de Itens -->
                <div class="cupom-tabela-itens">
                  <div class="cupom-tabela-header">
                    <span class="cupom-col-qtd">QTD.</span>
                    <span class="cupom-col-desc">ITEM</span>
                    <span class="cupom-col-valor">VALOR</span>
                  </div>
                  <div class="cupom-tabela-row">
                    <span class="cupom-col-qtd">${litros ? parseFloat(litros).toFixed(3).replace('.', ',') : '0,000'}</span>
                    <span class="cupom-col-desc">${(solicitacao?.combustivel || 'COMBUSTÍVEL').toUpperCase()}</span>
                    <span class="cupom-col-valor">${calcularValorTotal()}</span>
                  </div>
                </div>

                <div class="cupom-fiscal-divider"></div>

                <!-- Total -->
                <div class="cupom-total-row">
                  <span class="cupom-total-label">TOTAL</span>
                  <span class="cupom-total-value">${calcularValorTotal()}</span>
                </div>

                <div class="cupom-fiscal-divider"></div>

                <!-- Data e Hora -->
                <div class="cupom-info-row">
                  <span class="cupom-info-label">DATA:</span>
                  <span class="cupom-info-value">${solicitacao?.data_formatada || '-'}</span>
                </div>
                <div class="cupom-info-row">
                  <span class="cupom-info-label">HORA:</span>
                  <span class="cupom-info-value">${solicitacao?.hora_formatada || '-'}</span>
                </div>

                <div class="cupom-fiscal-divider"></div>

                <!-- Atendente -->
                <div class="cupom-info-row">
                  <span class="cupom-info-label">ATENDENTE:</span>
                  <span class="cupom-info-value">${(user?.nome || 'SISTEMA').toUpperCase()}</span>
                </div>
                <div class="cupom-info-row">
                  <span class="cupom-info-label">CPF:</span>
                  <span class="cupom-info-value">${mascararCPF(user?.cpf)}</span>
                </div>
              </div>

              <div>
                <div class="cupom-fiscal-divider"></div>

                <!-- Assinatura 
                <div class="cupom-assinatura">
                  <p class="cupom-assinatura-texto">CONFIRMO QUE RECEBI O COMBUSTÍVEL.</p>
                  <div class="cupom-assinatura-linha">
                    <span>____________________________________</span>
                  </div>
                  <p class="cupom-assinatura-label">ASSINATURA DO MOTORISTA</p>
                </div>

                <div class="cupom-fiscal-divider"></div> -->

                <!-- Rodapé -->
                <div class="cupom-fiscal-footer">
                  <p>COMPRA FÁCIL - SISTEMA DE CONTROLE DE ABASTECIMENTO</p>
                  <p>DOCUMENTO EMITIDO ELETRONICAMENTE</p>
                </div>
              </div>
            </div>
            <script>
              window.onload = function() {
                window.print();
                setTimeout(function() {
                  window.close();
                }, 500);
              };
            <\/script>
          </body>
        </html>
      `;

      const printWindow = window.open('', '_blank', 'fullscreen=yes,scrollbars=yes');
      
      if (printWindow) {
        printWindow.document.write(htmlContent);
        printWindow.document.close();
      } else {
        alert('Por favor, permita pop-ups para imprimir o comprovante.');
      }
    }
  };

  return (
    <>
      <div className="cupom-modal-overlay" onClick={onClose}>
        <div className="cupom-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="cupom-modal-header">
            <div className="cupom-header-info">
              <FaReceipt className="cupom-icon" />
              <h2>Comprovante de Abastecimento</h2>
            </div>
            <button className="cupom-close-btn" onClick={onClose}>
              <FaTimes />
            </button>
          </div>

          <div className="cupom-body">
            <div className="cupom-paper" id="cupom-print">
              {/* Cabeçalho */}
              <div className="cupom-fiscal-header">
                <h2 className="cupom-fiscal-title">COMPROVANTE DE ABASTECIMENTO</h2>
                <div className="cupom-id-abastecimento">
                  CÓDIGO: {solicitacao?.id?.toString().padStart(6, '0') || '000000'}
                </div>
                <div className="cupom-fiscal-divider"></div>
              </div>

              {/* Estabelecimento */}
              <div className="cupom-estabelecimento">
                <p className="cupom-posto-label">POSTO</p>
                <h3 className="cupom-estabelecimento-nome">{posto?.nome || 'Posto não informado'}</h3>
                <p className="cupom-estabelecimento-endereco">{posto?.endereco || 'Endereço não informado'}</p>
              </div>

              <div className="cupom-fiscal-divider"></div>

              {/* Motorista */}
              <div className="cupom-info-row">
                <span className="cupom-info-label">Motorista:</span>
                <span className="cupom-info-value">{solicitacao?.motorista?.nome || solicitacao?.motorista || 'Não informado'}</span>
              </div>
              <div className="cupom-info-row">
                <span className="cupom-info-label">CPF:</span>
                <span className="cupom-info-value">{mascararCPF(solicitacao?.motorista?.cpf)}</span>
              </div>

              <div className="cupom-fiscal-divider"></div>

              {/* PLACA e VEÍCULO - JUNTOS E PRÓXIMOS */}
              <div className="cupom-placa-veiculo">
                <div className="cupom-info-row-small">
                  <span className="cupom-info-label">LOCAL:</span>
                  <span className="cupom-info-value">{solicitacao?.veiculo?.local || '-'}</span>
                </div>
                <div className="cupom-info-row-small">
                  <span className="cupom-info-label">PLACA:</span>
                  <span className="cupom-info-value">{solicitacao?.veiculo?.placa || '-'}</span>
                </div>
                <div className="cupom-info-row-small">
                  <span className="cupom-info-label">VEÍCULO:</span>
                  <span className="cupom-info-value">{solicitacao?.veiculo?.descricao || '-'}</span>
                </div>
              </div>

              <div className="cupom-fiscal-divider"></div>

              {/* Tabela de Itens */}
              <div className="cupom-tabela-itens">
                <div className="cupom-tabela-header">
                  <span className="cupom-col-qtd">QTD.</span>
                  <span className="cupom-col-desc">ITEM</span>
                  <span className="cupom-col-valor">VALOR</span>
                </div>
                <div className="cupom-tabela-row">
                  <span className="cupom-col-qtd">{litros ? parseFloat(litros).toFixed(3).replace('.', ',') : '0,000'}</span>
                  <span className="cupom-col-desc">{(solicitacao?.combustivel || 'COMBUSTÍVEL').toUpperCase()}</span>
                  <span className="cupom-col-valor">{calcularValorTotal()}</span>
                </div>
              </div>

              <div className="cupom-fiscal-divider"></div>

              {/* Total */}
              <div className="cupom-total-row">
                <span className="cupom-total-label">TOTAL</span>
                <span className="cupom-total-value">{calcularValorTotal()}</span>
              </div>

              <div className="cupom-fiscal-divider"></div>

              {/* Data e Hora */}
              <div className="cupom-info-row">
                <span className="cupom-info-label">Data:</span>
                <span className="cupom-info-value">{solicitacao?.data_formatada || '-'}</span>
              </div>
              <div className="cupom-info-row">
                <span className="cupom-info-label">Hora:</span>
                <span className="cupom-info-value">{solicitacao?.hora_formatada || '-'}</span>
              </div>

              <div className="cupom-fiscal-divider"></div>

              {/* Atendente */}
              <div className="cupom-info-row">
                <span className="cupom-info-label">Atendente:</span>
                <span className="cupom-info-value">{user?.nome || 'Sistema'}</span>
              </div>
              <div className="cupom-info-row">
                <span className="cupom-info-label">CPF:</span>
                <span className="cupom-info-value">{mascararCPF(user?.cpf)}</span>
              </div>

              <div className="cupom-fiscal-divider"></div>

              {/* Assinatura 
              <div className="cupom-assinatura">
                <p className="cupom-assinatura-texto">Confirmo que recebi o combustível.</p>
                <div className="cupom-assinatura-linha">
                  <span>____________________________________</span>
                </div>
                <p className="cupom-assinatura-label">ASSINATURA DO MOTORISTA</p>
              </div>*/}

              {/* Rodapé */}
              <div className="cupom-fiscal-footer">
                <p>COMPRA FÁCIL - Sistema de Controle de Abastecimento</p>
                <p>Documento emitido eletronicamente</p>
              </div>
            </div>
          </div>

          <div className="cupom-modal-footer">
            <button className="cupom-print-btn" onClick={handlePrint}>
              <FaPrint />
              <span>Imprimir Comprovante</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CupomFiscalModal;